module.exports = "<p>\r\n  permisos works!\r\n</p>\r\n"